import { Dispatch, SetStateAction, useEffect } from "react";
import { CartQuery } from "../lib/api";

export default function useDiscountPopupTimeout(
  cart: CartQuery["Cart"] | null,
  origin: string,
  setVisible: Dispatch<SetStateAction<boolean>>,
  setUsesDiscountModal: Dispatch<SetStateAction<boolean>>,
) {
  return useEffect(() => {
    if (origin === 'sms') return;
    if (!cart?.popup_discounts) return;

    const timeout = Math.max(cart?.popup_timeout, 0);

    setTimeout(() => {
      setVisible(true);
      setUsesDiscountModal(true);
    }, timeout);
  }, [cart, origin, setVisible]);
}
